module.exports = __webpack_public_path__ + "static/img/icon-level-04.d6eec821.svg";